import type { McpMapCameraResult } from "@/types/mcp-tools";
import { isMcpMapCameraResult } from "@/types/mcp-tools";

export const ZOOM_TO_FEATURES_EVENT = "zoomToFeatures";

export type ZoomToFeaturesEventDetail = {
  bounds: [number, number, number, number];
  padding?: number;
  maxZoom?: number;
  source?: string;
};

/** Применить контракт map_camera к карте через CustomEvent (слушает MapLibreMap). */
export function applyMcpMapCamera(
  result: unknown,
  options?: { source?: string },
): boolean {
  if (!isMcpMapCameraResult(result)) return false;
  const camera = result as McpMapCameraResult;
  const detail: ZoomToFeaturesEventDetail = {
    bounds: camera.bounds,
    padding: camera.padding,
    maxZoom: camera.max_zoom,
    source: options?.source ?? "mcp",
  };
  window.dispatchEvent(new CustomEvent(ZOOM_TO_FEATURES_EVENT, { detail }));
  return true;
}
